/* Root path for Audit Reports - SAF-13055*/

export const paths = {
    root: '/auditReports'
};

export const navigation = {
    details:{
        auditReport: auditReportTypeSelected => `/auditReports/${auditReportTypeSelected}`
    }
}
